import VendorRegistrationSection from './VendorRegistrationSection';

export default VendorRegistrationSection;
